module.exports = __webpack_public_path__ + "img/newBtn.73edd72f.png";